<template>
	<div>
		<div :id="'clientsFilterSpan' + filterId" style="font-size: 0.75em; position: fixed; visibility: hidden;">{{clientSelected}}</div>

		<input :list="'listClients' + filterId" name="clientsFilter" onfocus="this.value=''" @focusout="outOfFocus()" onchange="this.blur();" :id="'clientsFilter' + filterId" class="form-control" :style="'height: 33px; min-width: 10px;' + inputWidth" v-model="clientSelected" placeholder="Filter Client" required>

		<template v-if="clients_prop.length > 0 || names_prop.length > 0">
			<datalist v-if="clients_prop.length > 0" :id="'listClients' + filterId">
				<option value="All Clients"></option>
				<option v-for="client in clients_prop" :key="client._id + filterId" :value="`${client.hin_abx} - ${client.personal_data[0].full_name}`"></option>
			</datalist>

			<datalist v-else :id="'listClients' + filterId">
				<option v-for="(name, index) in names_prop" :key="hins_prop[index] + filterId" :value="hins_prop[index] + '-' + name"></option>
			</datalist>
		</template>

	</div>
</template>

<script>
	export default {
		name: 'FilterClient',

		props: {
			filterId: {
				type: String,
				default: String(Math.random())
			},

			clients_prop: {
				type: Array,
				default: () => { return [] }
			},

			names_prop: {
				type: Array,
				default: () => { return [] }
			},

			hins_prop: {
				type: Array,
				default: () => { return [] }
			}
		},

		data() {
			return {
				clients: [],
				clientSelected: 'All Clients',
				inputWidth: '',
			}
		},

		computed: {
		},

		watch: {
			clientSelected(newValue) {
				if (newValue.includes('All')) {
					this.$emit('changeFilterClient', 'all')
				}else {
					let indexSpace = newValue.indexOf(' ')
					let hin = newValue.substr(0, indexSpace)
					let selectedClient = this.clients_prop.find(obj => obj.hin_abx == hin)

					this.$emit('changeFilterClient', selectedClient)
				}

				setTimeout(() => {
					let el = document.getElementById('clientsFilterSpan' + this.filterId)
					this.inputWidth = String('width:' + (el.clientWidth + 60) + 'px;')
				}, 100)
			}
		},

		mounted() {
			// let totalChar = this.clientSelected.length
			// let el = document.getElementById('clientsFilterSpan' + this.filterId)
			// let style = window.getComputedStyle(el, null).getPropertyValue('font-size')
			// let fontSize = parseFloat(style)
			// this.inputWidth = String('width:' + (totalChar * fontSize) + 'px;')
		},

		methods: {
			outOfFocus() {
				if (document.getElementById('clientsFilter' + this.filterId).value == '') {
					document.getElementById('clientsFilter' + this.filterId).value = this.clientSelected
				}
			}
		}
	}
</script>